import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiLinux, SiAdobephotoshop, SiCanva, SiAffinitydesigner } from "react-icons/si";
import { MdVideoSettings } from "react-icons/md";
import chrome from "../../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiLinux fontSize={"24px"} />
        <div className="tech-icons-text">Linux</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={chrome} alt="Chrome" className="tech-icon-images" />
        <div className="tech-icons-text">Google Chrome</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">VS Code</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <MdVideoSettings fontSize={"24px"} />
        <div className="tech-icons-text">DaVinci Resolve</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobephotoshop fontSize={"24px"} />
        <div className="tech-icons-text">Photoshop</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCanva fontSize={"24px"} />
        <div className="tech-icons-text">Canva</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAffinitydesigner fontSize={"24px"} />
        <div className="tech-icons-text">Affinity</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
